const footerSections = [
  {
    title: "内容分区",
    links: [
      { id: "featured", label: "首屏推荐" },
      { id: "hk-classics", label: "港片精选" },
      { id: "action", label: "动作专区" },
      { id: "wuxia", label: "武侠片" },
    ],
  },
  {
    title: "继续浏览",
    links: [
      { id: "eras", label: "怀旧剧场" },
      { id: "keywords", label: "关键词解读" },
      { id: "browse", label: "片单筛选" },
      { id: "guide", label: "观影指南" },
    ],
  },
];

const footerTags = [
  "大师兄影视",
  "大师兄影视港片",
  "大师兄影视经典电影",
  "大师兄影视动作片",
  "大师兄影视武侠片",
  "大师兄影视老电影",
  "大师兄影视怀旧剧场",
];

export default function Footer() {
  const jump = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer className="w-full bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-8 pt-14 md:pt-16 pb-8">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-movie-2-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg md:text-xl font-bold text-background-50">大师兄影视</span>
            </div>
            <p className="mt-4 text-sm text-background-200/85 leading-relaxed max-w-md">
              一个以港片、经典电影、动作片、武侠片、老电影与怀旧剧场为主题的内容页面，
              把片单、年代脉络与观影线索整理成可浏览、可筛选的分区。
            </p>
            <p className="mt-4 text-xs text-background-200/65 leading-relaxed max-w-md">
              页面内容为影视主题的一般性整理与介绍，仅用于分享观影线索；不同版本与修复版之间可能存在差异，
              观看时以实际发行信息为准。
            </p>
          </div>

          {footerSections.map((section) => (
            <nav key={section.title} aria-label={section.title}>
              <h3 className="font-heading text-sm font-bold text-accent-400">{section.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.id}>
                    <a
                      href={`#${link.id}`}
                      onClick={(e) => {
                        e.preventDefault();
                        jump(link.id);
                      }}
                      className="text-sm text-background-200/80 hover:text-background-50 transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="max-w-6xl mx-auto mt-10 pt-6 border-t border-background-100/15">
          <ul className="flex flex-wrap gap-2">
            {footerTags.map((tag) => (
              <li key={tag} className="px-2.5 py-1 rounded-full bg-background-50/10 text-[11px] text-background-200/80 font-label">
                {tag}
              </li>
            ))}
          </ul>
          <div className="mt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 text-xs text-background-200/60">
            <p>大师兄影视 · 港片与经典电影主题内容页</p>
            <p>本页为内容展示页面，不提供在线播放与账号服务</p>
          </div>
        </div>
      </div>
    </footer>
  );
}